<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <!--  <pre>wan: {{device.config.network.interface.wan.proto}} </pre> -->
        <b-row>
            <b-col sm=8>
                <b-card border-variant="light">
                    <div slot="header">
                        <strong>LAN: (Internal Network) </strong>
                        <!--   <pre>Data: {{$data}}</pre><pre>changed: {{changed}}</pre>  -->
                    </div>
                    <div>
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-form-group label="LAN IP Address:" label-for="lan0_0_ipaddr">
                                <b-form-input type="text" v-model="device.config.network.interface.lan.ipaddr" v-validate.initial="'required|ip'" id="lan0_0_ipaddr" name="LAN IP" class="form-control" :class="{'is-invalid': submitted && verrors.has('LAN IP') }" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('LAN IP')" class="invalid-feedback">{{ errors.first('LAN IP') }}</div>
                            </b-form-group>
                            <b-form-group label="LAN Netmask:" label-for="lan0_0_netmask">
                                <b-form-input type="text" v-model="device.config.network.interface.lan.netmask" v-validate.initial="'required|ip'" id="lan0_0_netmask" name="LAN Netmask" class="form-control" :class="{'is-invalid': submitted && verrors.has('LAN Netmask') }" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('LAN Netmask')" class="invalid-feedback">{{ errors.first('LAN Netmask') }}</div>
                            </b-form-group>
                            <b-form-group label="DHCP Start:" label-for="device.config.dhcp.dhcp.lan.start" description="Lowest leased address as offset from the network address.">
                                <b-form-input type="text" v-model="device.config.dhcp.dhcp.lan.start" v-validate.intial="'required'" id="lan0_0_dhcp_start" name="DHCP Start Address" class="form-control" :class="{'is-invalid': submitted && verrors.has('DHCP Start Address') }" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('DHCP Start Address')" class="invalid-feedback">{{ errors.first('DHCP Start Address') }}</div>
                            </b-form-group>
                            <b-form-group label="Number of Leases:" label-for="device.config.dhcp.dhcp.lan.limit" description="Maximum number of leased addresses. ">
                                <b-form-input type="text" v-model="device.config.dhcp.dhcp.lan.limit" v-validate.initial="'required'" id="lan0_0_dhcp_end" name="DHCP End Address" class="form-control" :class="{'is-invalid': submitted && verrors.has('DHCP End Address') }" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('DHCP End Address')" class="invalid-feedback">{{ errors.first('DHCP End Address') }}</div>
                            </b-form-group>
                            <div class="text-center">
                                <!-- TODO only activate when dirty -->
                                <button v-if="readonly" :disabled="verrors.any()" class="btn btn-primary">Save</button>
                                <!--  <b-button type="reset" variant="danger">Reset</b-button> -->
                                <!-- <button @click.prevent="reRender">Reset</button> -->
                            </div>
                        </b-form>
                    </div>
                </b-card>
            </b-col>
            <b-col sm=4>
                <b-card border-variant="light">
                    <div slot="header">
                        <strong>Tasks</strong>
                    </div>
                    <Tasks :device="device" :changed="changed" :changes="changes"></Tasks>
                </b-card>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import Tasks from "@/readynet/devices/network/Tasks";

export default {
    components: {
        ValidationProvider,
        Multiselect,
        Tasks,
    },
    props: {
        device: {
            type: Object,
            required: true,
        },
        changed: {
            type: Array,
        },
        changes: {
            type: Object,
        },
    },

    data() {
        return {
            loading: false,
            submitted: false,

        }
    },

    methods: {

        mounted() {},
        updateChanged(par, val, nam) {
            for (var i = this.changed.length - 1; i >= 0; i--) {
                if (this.changed[i].param === par) {
                    this.changed.splice(i, 1);
                }
            }
            this.changed.push({ param: par, value: val, name: nam })
            this.$set(this.changes, par, val)
        },

        onSubmit() {
            this.submitted = true;
            // console.log("Invalid " + (this.$validator.fields).map(field => field.flags.invalid))
            // console.log("Dirty " + (this.$validator.fields).map(field => field.flags.dirty))
            // console.log("IP dirty " + this.veeFields['LAN IP'].dirty);
            // console.log("netmask dirty " + this.veeFields['LAN Netmask'].dirty);

            // Object.keys(this.veeFields).every(field => {
            //   if (this.veeFields[field].dirty) {
            //     console.log("MSG:", this.veeFields[field] + " ", field)

            //   }
            // });

            this.$validator.validate().then(valid => {

                if (valid) {
                    // need to simplify this
                    if (this.veeFields['LAN IP'].dirty) {
                        this.updateChanged("lan0_0_ipaddr", this.device.config.network.interface.lan.ipaddr, "LAN IP Address")
                    }
                    if (this.veeFields['LAN Netmask'].dirty) {
                        this.updateChanged("lan0_0_netmask", this.device.config.network.interface.lan.netmask, "LAN Netmask")
                    }
                    if (this.veeFields['DHCP Start Address'].dirty) {
                        this.updateChanged("lan0_0_dhcp_start", this.device.config.dhcp.dhcp.lan.start, "DHCP Start")
                    }
                    if (this.veeFields['DHCP End Address'].dirty) {
                        this.updateChanged("lan0_0_dhcp_end", this.device.config.dhcp.dhcp.lan.limit, "Number of Leases")
                    }

                    // this.$router.push("/#/devices");
                } else {
                    console.log("LAN submitted, INVALID");
                }
            });
        },

    }, // end methods
    computed: {
        readonly() {
            return this.$can('device','edit')
        }
    },
};
</script>
// isFormValid () { // // loop over all contents of the fields object and check if they exist and valid or valid == null. // return Object.keys(this.veeFields).every(field => { // return this.veeFields[field] && (this.veeFields[field].valid || (this.veeFields[field].valid == null)); // }); // } // toArray(obj_obj) { // return Object.keys(obj_obj).map(i => obj_obj[i]); // }, // computed:{ // local: { // get() { // return this.params // }, // set(val) { // // this.$emit('input', val) // } // }, // }, // watch:{ // params:{ // // deep: true, // handler(){ // this.my = this.params // } // }, // },
